import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconContextSearch12 from './IconContextSearch12';
import IconContextSearch16 from './IconContextSearch16';
import IconContextSearch20 from './IconContextSearch20';
import IconContextSearch24 from './IconContextSearch24';
import IconContextSearch32 from './IconContextSearch32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconContextSearch = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconContextSearch12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconContextSearch16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconContextSearch20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconContextSearch24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconContextSearch32 {...props} />}
        </span>
    );
};
IconContextSearch.displayName = 'FondueIconContextSearch';

export default memo(IconContextSearch);
